import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import withSizes from 'react-sizes';
import {
  HotelAmenitiesSection,
  HotelDescription,
  HotelInfo,
  HotelShortInfo,
  OurRecommendation,
  HotelAlsoBought,
  HotelReviews,
  HotelHashtag,
  FinePrint
} from "../index";
import {
  HotelPanelMobile,
  HotelPanel,
  ProductGallery
} from '../../containers';

import {
  HotelLayoutTag,
  HotelTwoColumnLayout,
  HotelTwoColumnContainer,
  HotelLayoutContent,
  HotelLayoutAside,
  HotelLayoutSmallTwoColumns,
  HotelLayoutSmallColumn,
  HotelLayoutDesktopTwoColumns,
  HotelLayoutDesktopColumn,
} from './styles';

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
  isTablet: width >= 768,
  isDesktop: width >= 1024,
});

@withSizes(mapSizesToProps)
class HotelLayout extends PureComponent {
  static propTypes = {
    isMobile: PropTypes.bool,
    isDesktop: PropTypes.bool,
    isTablet: PropTypes.bool,
    hotelType: PropTypes.number,
    address: PropTypes.instanceOf(Object),
    rating: PropTypes.number,
    name: PropTypes.string,
    recommendation: PropTypes.string,
    reviews: PropTypes.instanceOf(Object),
    workingHours: PropTypes.string,
    checkIn: PropTypes.string,
    finePrint: PropTypes.instanceOf(Array),
    amenities: PropTypes.instanceOf(Array),
    parking: PropTypes.string,
    offers: PropTypes.string,
    instagram: PropTypes.instanceOf(Object),
    productId: PropTypes.string,
    products: PropTypes.instanceOf(Array),
    hotelPhotos: PropTypes.instanceOf(Array),
    counter: PropTypes.number,
    isComingSoon: PropTypes.bool,
    referer: PropTypes.string,
    tax: PropTypes.number,
  };

  render() {
    const {
      isDesktop,
      isTablet,
      isMobile,
      hotelType,
      address,
      rating,
      name,
      recommendation,
      reviews,
      workingHours,
      checkIn,
      finePrint,
      amenities,
      parking,
      offers,
      instagram,
      productId,
      products,
      hotelPhotos,
      counter,
      isComingSoon,
      referer,
      tax,
      isPreview,
      isOnboardingPreview,
    } = this.props;

    let content;
    const { city, zipCode, state, neighborhood, street } = address;
    const { hashtags } = instagram;
    const additionalAmenities = [{ type: '99', list: offers }, { type: '98', list: parking }];

    if (isDesktop) {
      content = (
        <HotelTwoColumnLayout>
          <HotelTwoColumnContainer>
            <HotelLayoutContent>
              <HotelInfo
                hotelType={hotelType}
                city={city}
                heading={name}
              />
              <HotelDescription
                products={products}
              />
              {amenities.length > 0 && (
                <HotelAmenitiesSection
                  amenities={amenities}
                  additionalAmenities={additionalAmenities}
                />
              )}
              <HotelShortInfo
                address={`${street} ${neighborhood} ${state}, ${zipCode}`}
                workingHours={workingHours}
                checkIn={checkIn}
              />
              {recommendation && <OurRecommendation hotelType={hotelType} recommendation={recommendation} />}
              {reviews.total > 0 && <HotelReviews reviewsData={{ ...reviews, productId }} />}
              {(hashtags || finePrint) && (
                <HotelLayoutDesktopTwoColumns>
                  {finePrint && (
                    <HotelLayoutDesktopColumn>
                      <FinePrint finePrint={finePrint} />
                    </HotelLayoutDesktopColumn>
                  )}
                  {hashtags && (
                    <HotelLayoutDesktopColumn>
                      <HotelHashtag hashtag={hashtags} />
                    </HotelLayoutDesktopColumn>
                  )}
                </HotelLayoutDesktopTwoColumns>
              )}
              <HotelAlsoBought referer={referer} />
            </HotelLayoutContent>
            <HotelLayoutAside>
              <HotelPanel
                products={products}
                totalReviews={reviews.total}
                rating={rating}
                counter={counter}
                isComingSoon={isComingSoon}
                tax={tax}
                isPreview={isPreview}
                isOnboardingPreview={isOnboardingPreview}
              />
            </HotelLayoutAside>
          </HotelTwoColumnContainer>
        </HotelTwoColumnLayout>
      );
    } else if (isTablet) {
      content = (
        <HotelLayoutTag>
          <HotelLayoutSmallTwoColumns>
            <HotelLayoutSmallColumn>
              <HotelInfo
                hotelType={hotelType}
                city={city}
                heading={name}
              />
              <HotelDescription
                products={products}
              />
            </HotelLayoutSmallColumn>
            <HotelPanel
              products={products}
              totalReviews={reviews.total}
              rating={rating}
              counter={counter}
              isComingSoon={isComingSoon}
              tax={tax}
              isPreview={isPreview}
              isOnboardingPreview={isOnboardingPreview}
            />
          </HotelLayoutSmallTwoColumns>
          {amenities.length > 0 && (
            <HotelAmenitiesSection
              amenities={amenities}
              additionalAmenities={additionalAmenities}
            />
          )}
          <HotelShortInfo
            address={`${street} ${neighborhood} ${state}, ${zipCode}`}
            workingHours={workingHours}
            checkIn={checkIn}
          />
          {recommendation && <OurRecommendation hotelType={hotelType} recommendation={recommendation} />}
          {reviews.total > 0 && <HotelReviews reviewsData={{ ...reviews, productId }} />}
          {(hashtags || finePrint) && (
            <HotelLayoutDesktopTwoColumns>
              {finePrint && (
                <HotelLayoutDesktopColumn>
                  <FinePrint finePrint={finePrint} />
                </HotelLayoutDesktopColumn>
              )}
              {hashtags && (
                <HotelLayoutDesktopColumn>
                  <HotelHashtag hashtag={hashtags} />
                </HotelLayoutDesktopColumn>
              )}
            </HotelLayoutDesktopTwoColumns>
          )}
          <HotelAlsoBought referer={referer} />
        </HotelLayoutTag>
      );
    } else if (isMobile) {
      content = (
        <HotelLayoutTag>
          <HotelPanelMobile
            products={products}
            totalReviews={reviews.total}
            rating={rating}
            counter={counter}
            isComingSoon={isComingSoon}
            tax={tax}
            isPreview={isPreview}
            isOnboardingPreview={isOnboardingPreview}
          />
          <HotelInfo
            hotelType={hotelType}
            city={city}
            heading={name}
          />
          <HotelDescription
            products={products}
          />
          {amenities.length > 0 && (
            <HotelAmenitiesSection
              amenities={amenities}
              additionalAmenities={additionalAmenities}
            />
          )}
          <HotelShortInfo
            address={`${street} ${neighborhood} ${state}, ${zipCode}`}
            workingHours={workingHours}
            checkIn={checkIn}
          />
          {recommendation && <OurRecommendation hotelType={hotelType} recommendation={recommendation} />}
          {reviews.total > 0 && <HotelReviews reviewsData={{ ...reviews, productId }} />}
          {hashtags && <HotelHashtag hashtag={hashtags} />}
          <HotelAlsoBought referer={referer} />
        </HotelLayoutTag>
      );
    }

    return (
      <Fragment>
        {hotelPhotos.length > 0 && <ProductGallery slidesData={hotelPhotos} hotelName={name} />}
        {content}
      </Fragment>
    );
  }
}

export default HotelLayout;
